export default {
  props: {
    name: {
      type: String,
      required: true
    },
    placeholder: {
      type: String
    },
    inForm: {
      type: Boolean,
      default: false
    },
    title: String,
    code: String,
    icon: {
      type: String
    },
    value: {
      type: String | Array | Object | Boolean | Number
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isHidden: {
      type: Boolean,
      default: false
    },
    prepend: {
      type: String |Boolean,
      default: false
    },
    append: {
      type: String |Boolean,
      default: false
    },
    hasLabel: {
      type: Boolean,
      default: true
    },
    autoLimit:{
      type: Boolean,
      default: false
    }
  },
  filters: {
    capitalize(value) {
      if (!value) {
        return ''
      } else {
        return value.toString() + "："
      }
    }
  },
  computed: {
    endTitle() {
      if (this.hasLabel) {
        return this.title
      } else {
        return ''
      }
    },
    isRequired() {
      return !!this.validate.required
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/FromBase/mixin/base.js